import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditUsersForm from './EditUsersForm'
import ModalHeader from './ModalHeader'
import UsersLoader from './_load/UsersLoader'

const EditUsersModal = props => {
  return (
    <ControlledModal fullScreen noPadding {...props}>
      <ModalHeader />
      <PermissionChecker any={['createUser', 'editUser']}>
        <UsersLoader>
          <EditUsersForm />
        </UsersLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditUsersModal
